import axios from "axios";
import cookie from "react-cookies";

/**
 * URL to send request
 */
const url = process.env.React_App_Api_url;
// const url = "http://localhost:5000/user";

export const getUserInfo = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${url}/getUserInfo`, { headers: { uid: cookie.load("uid") } })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "server timed out"));
  });
};

export const userSignUp = (formData) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${url}/signup`, formData)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"))
  );

export const saveNewAddress = (formData) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${url}/saveNewAddress`, formData)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"))
  );

export const editAddress = (aid, uid, formData) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${url}/updateAddress`, { aid, uid, formData })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"))
  );

export const updatePrimary = (aid, uid) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${url}/updatePrimaryAddress`, { aid, uid: cookie.load("uid") })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"))
  );
export const deleteAddress = (aid, uid) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${url}/deleteAddress`, { aid, uid: cookie.load("uid") })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"))
  );
export const registerNotification = (uid, data) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${url}/registerNotification`, data, { headers: { uid } })
      .then((res) => resolve(res))
      .catch((err) => reject(err?.response?.data || "Server Offline"))
  );

export const updateInfo = (data) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${url}/updateInfo`, data, {
        headers: { uid: cookie.load("uid") },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server Offline"))
  );

export const getNotificationStatus = (auth, id) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${url}/getNotificationStatus`, {
        headers: {
          uid: cookie.load("uid") || id,
          auth,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server Offline"))
  );

export const updateNotificationState = (state) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${url}/updateNotification/${state ? 1 : 0}`, {
        headers: {
          uid: cookie.load("uid"),
          auth: localStorage.getItem("auth"),
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server Offline"))
  );

export const updateLoginState = (state, id) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${url}/updateLoginState/${state ? 1 : 0}`, {
        headers: {
          uid: cookie.load("uid") || id,
          auth: localStorage.getItem("auth"),
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server Offline"))
  );

// Send Utm data
export const utmData = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${url}/utmData`, data, {
        headers: {
          id: cookie.load("uid"),
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server Offline"));
  });
};
